{
  "MACROS": {
    "HEADER": "ماكروس",
    "DESCRIPTION": "الماكرو هو مجموعة من الإجراءات المحفوظة التي تساعد وكلاء خدمة العملاء على إكمال المهام بسهولة. يمكن للوكلاء تحديد مجموعة من الإجراءات مثل وضع علامة على محادثة مع تسمية، وإرسال نص بريد إلكتروني، وتحديث سمة مخصصة، إلخ. ويمكنهم تنفيذ هذه الإجراءات بنقرة واحدة.",
    "LEARN_MORE": "تعلم المزيد حول الماكرو",
    "HEADER_BTN_TXT": "إضافة ماكرو جديد",
    "HEADER_BTN_TXT_SAVE": "حفظ الماكرو",
    "LOADING": "جاري جلب الماكروس",
    "ERROR": "حدث خطأ ما. الرجاء المحاولة مرة أخرى",
    "ORDER_INFO": "سيتم تشغيل الماكرو بالترتيب الذي تضيفه إجراءاتك. يمكنك إعادة ترتيبهم بسحبهم بواسطة المعالج بجانب كل عقدة.",
    "ADD": {
      "FORM": {
        "NAME": {
          "LABEL": "اسم الماكرو",
          "PLACEHOLDER": "أدخل اسم الماكرو الخاص بك",
          "ERROR": "الاسم مطلوب لإنشاء الماكرو"
        },
        "ACTIONS": {
          "LABEL": "الإجراءات"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "تمت إضافة الماكرو بنجاح",
        "ERROR_MESSAGE": "غير قادر على إنشاء الماكرو ، الرجاء المحاولة مرة أخرى لاحقاً"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "الاسم",
        "CREATED BY": "تم إنشاؤها بواسطة",
        "LAST_UPDATED_BY": "آخر تحديث بواسطة",
        "VISIBILITY": "الظهور"
      },
      "404": "لم يتم العثور على الماكروس"
    },
    "DELETE": {
      "TOOLTIP": "حذف الماكرو",
      "CONFIRM": {
        "MESSAGE": "هل أنت متأكد من الحذف ",
        "YES": "نعم، احذف",
        "NO": "لا"
      },
      "API": {
        "SUCCESS_MESSAGE": "تم حذف الماكرو بنجاح",
        "ERROR_MESSAGE": "حدث خطأ أثناء حذف الماكرو. الرجاء المحاولة مرة أخرى في وقت لاحق"
      }
    },
    "EDIT": {
      "TOOLTIP": "تعديل الماكرو",
      "API": {
        "SUCCESS_MESSAGE": "تم تحديث الماكرو بنجاح",
        "ERROR_MESSAGE": "تعذر تحديث الماكرو ، الرجاء المحاولة مرة أخرى لاحقاً"
      }
    },
    "EDITOR": {
      "START_FLOW": "بداية الإجرائات",
      "END_FLOW": "نهاية الإجرائات",
      "LOADING": "جاري جلب الماكروس",
      "ADD_BTN_TOOLTIP": "إضافة إجراء جديد",
      "DELETE_BTN_TOOLTIP": "حذف الإجراء",
      "VISIBILITY": {
        "LABEL": "الرؤية الخاصة بالماكرو",
        "GLOBAL": {
          "LABEL": "عامة",
          "DESCRIPTION": "هذا الماكرو متاح بشكل عام لجميع الوكلاء في هذا الحساب."
        },
        "PERSONAL": {
          "LABEL": "خاص",
          "DESCRIPTION": "هذا الماكرو سيكون خاصا لك ولن يكون متاحا للآخرين."
        }
      }
    },
    "EXECUTE": {
      "BUTTON_TOOLTIP": "تنفيذ",
      "PREVIEW": "معاينة الماكرو",
      "EXECUTED_SUCCESSFULLY": "تم تنفيذ الماكرو بنجاح"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "مفتاح الخاصية مطلوب",
      "FILTER_OPERATOR_REQUIRED": "عامل التصفية مطلوب",
      "VALUE_REQUIRED": "القيمة مطلوبة",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "القيمة يجب أن تكون بين 1 و 998",
      "ACTION_PARAMETERS_REQUIRED": "معلمات الإجراء مطلوبة",
      "ATLEAST_ONE_CONDITION_REQUIRED": "شرط واحد على الأقل مطلوب",
      "ATLEAST_ONE_ACTION_REQUIRED": "إجراء واحد على الأقل مطلوب"
    },
    "ACTIONS": {
      "ASSIGN_TEAM": "تعيين فريق",
      "ASSIGN_AGENT": "تعيين وكيل",
      "ADD_LABEL": "إضافة وسم",
      "REMOVE_LABEL": "إزالة وسم",
      "REMOVE_ASSIGNED_TEAM": "إزالة الفريق المعيَّن",
      "SEND_EMAIL_TRANSCRIPT": "إرسال نص المحادثة عبر البريد الإلكتروني",
      "MUTE_CONVERSATION": "كتم صوت المحادثة",
      "SNOOZE_CONVERSATION": "تأجيل المحادثة",
      "RESOLVE_CONVERSATION": "حل المحادثة",
      "SEND_ATTACHMENT": "إرسال مرفق",
      "SEND_MESSAGE": "إرسال رسالة",
      "CHANGE_PRIORITY": "تغيير الأولوية",
      "ADD_PRIVATE_NOTE": "إضافة ملاحظة خاصة",
      "SEND_WEBHOOK_EVENT": "إرسال حدث Webhook"
    },
    "ACTION_VALUES": {
      "SELF": "أنا"
    }
  }
}
